module.exports = __webpack_public_path__ + "img/face-sad.f3673d72.svg";